module.exports = __webpack_public_path__ + "media/images/responsive/flow/flow1-9d5946b8187376f81a5cb193b58da266.jpg";